import { useState } from "react";
import { useEffect } from "react";
import { Fragment } from "react";
import { connect } from "react-redux";

import UserIcon from "@mui/icons-material/AccountCircle";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import BioIcon from "@mui/icons-material/Fingerprint";
import PreviewIcon from "@mui/icons-material/Preview";
import RemoveIcon from "@mui/icons-material/Remove";
import { Tab } from "@mui/material";
import { Typography } from "@mui/material";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import { useTheme } from "@mui/material/styles";
import { v4 as uuid } from "uuid";

import constants from "../../assets/constants";
import * as OmniDataAPI from "../../data/omniDataAPI";
import { capitalizeAllWords, deepCopyObject, isValidEmail } from "../../utils/helpers";
import TextInputDialog from "../dialogs/textInputDialog";
import Dialog from "../ui/omniDialog";
import DialogActions from "../ui/omniDialogActions";
import DialogContent from "../ui/omniDialogContent";
import DialogList from "../ui/omniDialogList";
import DialogTab from "../ui/omniDialogTab";
import DialogTabs from "../ui/omniDialogTabs";
import DialogTitle from "../ui/omniDialogTitle";
import OmniMenuItem from "../ui/omniMenuItem";
import OmniPhoneNumberField from "../ui/omniPhoneNumberField";
import OmniResponsiveButton from "../ui/omniResponsiveButton";
import OmniTextField from "../ui/omniTextField";
import OmniUserListItem from "../ui/omniUserListItem";
import AlertDialog from "./alertDialog";

const InviteDialog = props => {
  const {
    open,
    tabId = 0,
    dialogTitle = "Edit Invitation",
    okMessage = "OK",
    cancelMessage = "Cancel",
    deleteMessage = "Remove",
    maxWidth = "sm",
    fullWidth = true,
    omniODM, //omni Data Model Object, a root level object representation, Pass in a COPY, the only way this works
    onDelete = null,
    organizationODM,
  } = props;

  const [editedODM, setEditedODM] = useState(omniODM);

  const [readyOk, setReadyOk] = useState(false);
  const [givenNameValid, setGivenNameValid] = useState(false);
  const [familyNameValid, setFamilyNameValid] = useState(false);
  const [mobilePhoneValid, setMobilePhoneValid] = useState(false);
  const [emailValid, setEmailValid] = useState(false);

  const [onboardedUserIDs] = useState(omniODM.omniData._onboarded_users);

  const [onboardedUserODMs, setOnboardedUserODMs] = useState(null);

  const [userName, setUserName] = useState(
    omniODM.omniData.desiredUserName ? omniODM.omniData.desiredUserName : "",
  );

  const [onboardingHTML, setOnboardingHTML] = useState("");

  const [localAssessmentTypes, setLocalAssessmentTypes] = useState(
    constants.supportedAssessmentTypes.slice(),
  );

  const [onboardingAssessmentType, setOnboardingAssessmentType] = useState(
    organizationODM.omniData.defaultAssessmentType,
  );

  useEffect(() => {
    try {
      if (organizationODM) {
        const theSupportedTypes = [];

        for (let index = 0; index < constants.supportedAssessmentTypes.length; ++index) {
          if (
            organizationODM.omniData.supportedAssessmentTypes.includes(
              constants.supportedAssessmentTypes[index].value,
            ) ||
            constants.supportedAssessmentTypes[index].value === onboardingAssessmentType
          ) {
            theSupportedTypes.push(constants.supportedAssessmentTypes[index]);
          }
        }

        setLocalAssessmentTypes(theSupportedTypes);
      }
    } catch (error) {
      console.log(error);
    }
  }, [organizationODM, onboardingAssessmentType]);

  useEffect(() => {
    try {
      if (editedODM.omniData.onboardingHTML) {
        const splitPath = editedODM.omniData.onboardingHTML.split("/");
        setOnboardingHTML(splitPath[splitPath.length - 1]);
      } else {
        setOnboardingHTML("");
      }
    } catch (error) {
      console.log(error);
    }
  }, [editedODM.omniData.onboardingHTML]);

  const [showOnboardingHTML, setShowOnboardingHTML] = useState(false);

  useEffect(() => {
    try {
      setLocalAssessmentTypes(constants.supportedAssessmentTypes.slice());

      if (editedODM.omniData.onboardingAssessmentType) {
        setOnboardingAssessmentType(editedODM.omniData.onboardingAssessmentType);
      } else {
        setOnboardingAssessmentType(organizationODM.omniData.defaultAsssesmentType);
      }
    } catch (error) {
      console.log(error);
    }
  }, [editedODM.omniData.onboardingAssessmentType, organizationODM]);

  const loadOnboardedUserODMs = (theIds, theInviteType) => {
    try {
      for (let index = 0; index < theIds.length; ++index) {
        if (theInviteType === constants.onboardingUserType.partner) {
          let theID = theIds[index];
          OmniDataAPI.getPartner(theID).then(response => {
            if (response != null) {
              setOnboardedUserODMs(prevState => {
                if (prevState != null) {
                  let theReturn = prevState.slice();
                  theReturn.push(response);
                  return theReturn;
                } else {
                  return new Array(response);
                }
              });
            }
          });
        }
        if (theInviteType === constants.onboardingUserType.provider) {
          let theID = theIds[index];
          OmniDataAPI.getProvider(theID).then(response => {
            if (response != null) {
              setOnboardedUserODMs(prevState => {
                if (prevState != null) {
                  let theReturn = prevState.slice();
                  theReturn.push(response);
                  return theReturn;
                } else {
                  return new Array(response);
                }
              });
            }
          });
        }
        if (theInviteType === constants.onboardingUserType.administrator) {
          let theID = theIds[index];
          OmniDataAPI.getAdministrator(theID).then(response => {
            if (response != null) {
              setOnboardedUserODMs(prevState => {
                if (prevState != null) {
                  let theReturn = prevState.slice();
                  theReturn.push(response);
                  return theReturn;
                } else {
                  return new Array(response);
                }
              });
            }
          });
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (onboardedUserIDs != null && onboardedUserODMs == null) {
      loadOnboardedUserODMs(onboardedUserIDs, editedODM.omniData.userType);
    }
  }, [onboardedUserODMs, onboardedUserIDs, editedODM]);

  const updateUserODM = event => {
    try {
      editedODM.omniData.userData[event.target.id] = event.target.value;
      setEditedODM(deepCopyObject(editedODM));
    } catch (error) {
      console.log(error);
    }
  };

  const updateInviteODM = event => {
    try {
      editedODM.omniData[event.target.id] = event.target.value;
      setEditedODM(deepCopyObject(editedODM));
    } catch (error) {
      console.log(error);
    }
  };

  const updateUserType = event => {
    try {
      editedODM.omniData.userType = event.target.value;
      setEditedODM(deepCopyObject(editedODM));
    } catch (error) {
      console.log(error);
    }
  };

  const [showConfirm, setShowConfirm] = useState(false);
  const [tabIndex, setTabIndex] = useState(tabId);

  const onDeleteHandler = () => {
    onDelete(editedODM._id);
  };

  const onAcceptHandler = () => {
    // A little off the top
    editedODM.omniData.target = editedODM.omniData.target.trim();
    editedODM.omniData["desiredUserName"] = userName;
    editedODM.omniData.onboardingAssessmentType = onboardingAssessmentType;
    props.onAccept(editedODM);
  };

  const onCloseHandler = () => {
    props.onClose();
  };

  // Check given name
  useEffect(() => {
    editedODM.omniData.userData.givenName ? setGivenNameValid(true) : setGivenNameValid(false);
  }, [editedODM.omniData.userData.givenName]);

  // Check family name
  useEffect(() => {
    editedODM.omniData.userData.familyName ? setFamilyNameValid(true) : setFamilyNameValid(false);
  }, [editedODM.omniData.userData.familyName]);

  // Check mobile phone
  useEffect(() => {
    // editedODM.omniData.mobilePhone &&
    // !editedODM.omniData.mobilePhone.includes(" ") &&
    // RegExp(`([0-9]{3})?[0-9]{3}-?[0-9]{4}`).exec(editedODM.omniData.mobilePhone)
    editedODM.omniData.userData.mobilePhone &&
    RegExp(/^\D*(\d\D*){10}$/).exec(editedODM.omniData.userData.mobilePhone)
      ? setMobilePhoneValid(true)
      : setMobilePhoneValid(false);
  }, [editedODM.omniData.userData.mobilePhone]);

  // Check email
  useEffect(() => {
    isValidEmail(editedODM.omniData.userData.email) ? setEmailValid(true) : setEmailValid(false);
  }, [editedODM.omniData.userData.email]);

  useEffect(() => {
    givenNameValid && familyNameValid && emailValid && mobilePhoneValid
      ? setReadyOk(true)
      : setReadyOk(false);
  }, [givenNameValid, familyNameValid, emailValid, mobilePhoneValid]);

  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          onCloseHandler();
        }
      }}
      disableEscapeKeyDown
      maxWidth={maxWidth}
      fullWidth={fullWidth}
    >
      <DialogTitle onClose={onCloseHandler}>{dialogTitle}</DialogTitle>

      <DialogTabs tabIndex={tabIndex} setTabIndex={setTabIndex}>
        <Tab
          key={`tab0`}
          icon={<BioIcon />}
          label={
            givenNameValid && familyNameValid && mobilePhoneValid && emailValid
              ? `Credentials`
              : `Credentials *`
          }
          disabled={
            omniODM.omniData.inviteType === constants.inviteType.shared &&
            (omniODM.omniData.target === `Default Shareable Invitation` ||
              omniODM.omniData.target === `Default Sharable Invitation`)
          }
        />
        <Tab key={`tab1`} icon={<UserIcon />} label={"Used By"} disabled={omniODM._id == null} />
      </DialogTabs>

      <DialogContent>
        <DialogTab selectedIndex={tabIndex} index={0}>
          <Typography
            variant="overline"
            sx={{
              marginTop: theme.spacing(1),
              marginBottom: `-${theme.spacing(1)}`,
              userSelect: "none",
            }}
          >
            Invitation Configuration
          </Typography>
          <Grid container size={12}>
            <Grid container spacing={1} size={12}>
              <Grid
                size={{
                  xs: 12,
                  sm:
                    organizationODM.omniData.organizationType !==
                    constants.organizationTypeEnums.botpressTesting
                      ? 6
                      : 12,
                }}
              >
                <OmniTextField
                  fullWidth
                  label="User Type"
                  select
                  name={uuid()} //prevents AutoComplete Suggestions
                  variant="outlined"
                  id={"userType"}
                  value={editedODM.omniData.userType}
                  onChange={event => {
                    updateUserType(event);
                  }}
                  placeholder={"User Type"}
                  required
                >
                  {editedODM.omniData.inviteType === constants.inviteType.single && (
                    <OmniMenuItem
                      key={constants.onboardingUserType.administrator}
                      value={constants.onboardingUserType.administrator}
                    >
                      {capitalizeAllWords(constants.onboardingUserType.administrator)}
                    </OmniMenuItem>
                  )}

                  {editedODM.omniData.inviteType === constants.inviteType.single && (
                    <OmniMenuItem
                      key={constants.onboardingUserType.provider}
                      value={constants.onboardingUserType.provider}
                    >
                      {capitalizeAllWords(constants.onboardingUserType.provider)}
                    </OmniMenuItem>
                  )}

                  {editedODM.omniData.inviteType === constants.inviteType.single && (
                    <OmniMenuItem
                      key={constants.onboardingUserType.partner}
                      value={constants.onboardingUserType.partner}
                    >
                      {capitalizeAllWords(constants.onboardingUserType.partner)}
                    </OmniMenuItem>
                  )}

                  {editedODM.omniData.inviteType === constants.inviteType.shared && (
                    <OmniMenuItem
                      key={constants.onboardingUserType.partner}
                      value={constants.onboardingUserType.partner}
                    >
                      {`Shared ${capitalizeAllWords(constants.onboardingUserType.partner)}`}
                    </OmniMenuItem>
                  )}
                  {editedODM.omniData.inviteType === constants.inviteType.shared && (
                    <OmniMenuItem
                      key={constants.onboardingUserType.provider}
                      value={constants.onboardingUserType.provider}
                    >
                      {capitalizeAllWords(constants.onboardingUserType.provider)}
                    </OmniMenuItem>
                  )}
                </OmniTextField>
              </Grid>

              {editedODM.omniData.userType === constants.onboardingUserType.administrator && (
                <Grid size={{ xs: 12, sm: 6 }}>
                  <OmniTextField
                    label="User Name"
                    type="textInput"
                    name={uuid()} //prevents AutoComplete Suggestions
                    variant="outlined"
                    id={"desiredUserName"}
                    value={userName}
                    error={userName.length === 0}
                    onChange={event => {
                      event.target.value = event.target.value.trim();
                      setUserName(event.target.value);
                    }}
                    placeholder={"Make it Unique"}
                    required
                  />
                </Grid>
              )}

              {editedODM.omniData.userType !== constants.onboardingUserType.administrator &&
                onboardingAssessmentType &&
                localAssessmentTypes &&
                organizationODM.omniData.organizationType !==
                  constants.organizationTypeEnums.botpressTesting && (
                  <Grid size={{ xs: 12, sm: 6 }}>
                    <OmniTextField
                      fullWidth
                      label="Onboarding Assessment"
                      select
                      name={uuid()} //prevents AutoComplete Suggestions
                      variant="outlined"
                      id={"onboardingAssessmentType"}
                      value={onboardingAssessmentType}
                      onChange={event => {
                        setOnboardingAssessmentType(event.target.value);
                      }}
                      placeholder={"Assessment Type"}
                      required
                    >
                      {localAssessmentTypes.map(assType => (
                        <OmniMenuItem key={assType.value} value={assType.value}>
                          {assType.label}
                        </OmniMenuItem>
                      ))}
                    </OmniTextField>
                  </Grid>
                )}

              <Grid container spacing={1} size={{ xs: 12 }}>
                <Grid size={{ xs: 12 }}>
                  <OmniTextField
                    fullWidth
                    label="Campaign Name"
                    type="textInput"
                    name={uuid()} //prevents AutoComplete Suggestions
                    variant="outlined"
                    id={"target"}
                    value={editedODM.omniData.target}
                    error={editedODM.omniData.target.length === 0}
                    onChange={event => {
                      updateInviteODM(event);
                    }}
                    placeholder={"What is this For?"}
                    required
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid container size={12}>
            <Typography
              variant="overline"
              sx={{
                marginTop: theme.spacing(1),
                marginBottom: `-${theme.spacing(1)}`,
                userSelect: "none",
              }}
            >
              {editedODM.omniData.inviteType === constants.inviteType.shared ? "Owner" : "Identity"}
            </Typography>
            <Grid container spacing={1} size={12}>
              <Grid size={{ xs: 12, sm: 6 }}>
                <OmniTextField
                  label="First"
                  type="textInput"
                  name={uuid()} //prevents AutoComplete Suggestions
                  variant="outlined"
                  id={"givenName"}
                  value={editedODM.omniData.userData.givenName}
                  error={!givenNameValid}
                  onChange={event => {
                    event.target.value = event.target.value.trim();
                    updateUserODM(event);
                  }}
                  placeholder={"First Name"}
                  required
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 6 }}>
                <OmniTextField
                  label="Last"
                  type="textInput"
                  name={uuid()} //prevents AutoComplete Suggestions
                  variant="outlined"
                  id={"familyName"}
                  value={editedODM.omniData.userData.familyName}
                  error={!familyNameValid}
                  onChange={event => {
                    event.target.value = event.target.value.trim();
                    updateUserODM(event);
                  }}
                  placeholder={"Last Name"}
                  required
                />
              </Grid>
            </Grid>
            {editedODM.omniData.inviteType === constants.inviteType.single && (
              <Grid container>
                <Typography
                  variant="overline"
                  sx={{ marginTop: theme.spacing(1), marginBottom: `-${theme.spacing(1)}` }}
                >
                  Contact Information
                </Typography>
                <Grid container spacing={1}>
                  <Grid size={{ xs: 12, sm: 6 }} md={8}>
                    <OmniTextField
                      label="Email"
                      type="textField"
                      name={uuid()} //prevents AutoComplete Suggestions
                      variant="outlined"
                      id={"email"}
                      value={editedODM.omniData.userData.email}
                      error={!emailValid}
                      onChange={event => {
                        updateUserODM(event);
                      }}
                      placeholder={"Primary Email Address"}
                      required
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 6 }} md={4}>
                    <OmniPhoneNumberField
                      label="Mobile Number"
                      name={uuid()} //prevents AutoComplete Suggestions
                      variant="outlined"
                      id={"mobilePhone"}
                      value={editedODM.omniData.userData.mobilePhone}
                      error={!mobilePhoneValid}
                      onChange={event => {
                        updateUserODM(event);
                      }}
                      onFocus={event => event.target.select()}
                      placeholder={"Your Phone Number"}
                      required
                    />
                  </Grid>
                </Grid>
              </Grid>
            )}

            {editedODM.omniData.userType !== constants.onboardingUserType.administrator && (
              <Grid size={{ xs: 12 }}>
                <Typography
                  variant="overline"
                  sx={{
                    marginTop: theme.spacing(1),
                    marginBottom: `-${theme.spacing(1)}`,
                    userSelect: "none",
                  }}
                >
                  Custom Onboarding HTML
                </Typography>
                <Grid
                  container
                  size={11}
                  marginBottom={1}
                  marginLeft={1}
                  spacing={1}
                  flexDirection={"row"}
                  justifyContent={"flex-start"}
                >
                  <Grid size="auto">
                    <OmniResponsiveButton
                      tooltipTitle="Set the Onboarding HTML"
                      buttonText={editedODM.omniData.onboardingHTML ? "remove" : "select"}
                      icon={editedODM.omniData.onboardingHTML ? <RemoveIcon /> : <AddIcon />}
                      component="label"
                      onClick={event => {
                        if (editedODM.omniData.onboardingHTML) {
                          event.target.value = "";
                          event.target["id"] = "onboardingHTML";
                          updateInviteODM(event);
                        } else {
                          setShowOnboardingHTML(true);
                        }
                      }}
                    />
                  </Grid>
                  <Grid size="auto">
                    <a
                      href={`${editedODM.omniData.onboardingHTML}`}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <OmniResponsiveButton
                        tooltipTitle="Preview Onboarding HTML"
                        buttonText="Preview"
                        component="label"
                        icon={<PreviewIcon />}
                        disabled={!editedODM.omniData.onboardingHTML}
                      />
                    </a>
                  </Grid>
                  {onboardingHTML && (
                    <Typography
                      variant="buttonText"
                      sx={{ marginLeft: theme.spacing(1), fontWeight: "bold" }}
                    >
                      {onboardingHTML}
                    </Typography>
                  )}
                </Grid>
              </Grid>
            )}
          </Grid>
        </DialogTab>

        <DialogTab selectedIndex={tabIndex} index={1}>
          <Fragment>
            {editedODM.omniData._onboarded_count != null && (
              <Typography
                variant="overline"
                sx={{ marginLeft: theme.spacing(2), paddingBottom: theme.spacing(1) }}
                noWrap
              >
                {`${editedODM.omniData._onboarded_count} Matching Result${
                  editedODM.omniData._onboarded_count !== 1 ? "s" : ""
                }`}
              </Typography>
            )}
            {onboardedUserODMs && (
              <DialogList>
                {onboardedUserODMs
                  .sort((a, b) => a.omniData.familyName.localeCompare(b.omniData.familyName))
                  .map((userODM, index) => {
                    return (
                      <OmniUserListItem
                        key={`inviteDialog-Users-${index}`}
                        userODM={userODM}
                        // onClickHandler={userODM => {
                        //   // setSelectedPatient(userODM);
                        // }}
                        // onNavigateHandler={userODM => {
                        //   // props.setPatientODMRequest(userODM);
                        //   // navigateToManagePortal();
                        // }}
                      />
                    );
                  })}
              </DialogList>
            )}
          </Fragment>
        </DialogTab>
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent="space-between" flexDirection={"row"}>
          <Grid size={{ xs: 6 }}>
            {omniODM._id != null && props.onDelete != null && (
              <OmniResponsiveButton
                icon={<DeleteIcon />}
                onClick={() => setShowConfirm(true)}
                buttonText={deleteMessage}
                tooltipTitle="Delete this Invite."
                disabled={onDelete == null}
              />
            )}
          </Grid>
          <Grid container justifyContent="flex-end" spacing={1}>
            <Grid>
              {cancelMessage && (
                <Button onClick={onCloseHandler} color="secondary" variant="contained">
                  {cancelMessage}
                </Button>
              )}
            </Grid>
            <Grid>
              <Button
                onClick={onAcceptHandler}
                color="secondary"
                disabled={!readyOk}
                variant="contained"
              >
                {editedODM.omniData.userType === constants.onboardingUserType.administrator
                  ? "Onboard"
                  : okMessage}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </DialogActions>
      {showConfirm && (
        <AlertDialog
          open={showConfirm}
          dialogTitle={`Confirm`}
          dialogMessage={"Are you sure you want to delete this Invite?"}
          onAccept={() => {
            onDeleteHandler();
            setShowConfirm(false);
          }}
          onClose={() => {
            setShowConfirm(false);
          }}
        />
      )}
      {showOnboardingHTML && (
        <TextInputDialog
          dialogTitle="Object URL"
          dialogMessage={`Paste the file URL into this text box.\nThe optimal width and height is ${"~800 x 600"}`}
          inputLabel={`${"Onboarding HTML File"}`}
          open={showOnboardingHTML}
          onAccept={theText => {
            let fileName = {
              target: { id: "onboardingHTML", value: theText },
            };
            updateInviteODM(fileName);
            setShowOnboardingHTML(false);
          }}
          onClose={() => {
            setShowOnboardingHTML(false);
          }}
        />
      )}
    </Dialog>
  );
};

const mapStateToProps = state => ({
  supportedAssessmentTypes: state.userSession.supportedAssessmentTypes,
  organizationODM: state.userSession.organizationODM,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(InviteDialog);
